import { useNavigate } from "react-router-dom";
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { IsAuthenticatedContext } from "auth";
import { DefaultAppPage, PublicPage } from "layouts";

import { TextInput } from "components/atoms/TextInput";
import * as styles from "../Login/styles";

import {
  GET_RESET,
  ResetResponse,
  ResetVars,
  GET_USER_NOTIFICATION_PREFERENCE,
  GetUserNotificationPreferenceResponse,
  UPDATE_EMAIL_NOTIFICATION_PREFERENCE,
  UpdateEmailNotificationResponse,
  UpdateEmailNotificationVars,
} from "./queries";
import { useEffect, useRef, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import { QUERY_SPECIALISTS } from "hooks/useSpecialistDropDown";
import PasswordEyeIcon from "assets/svg/Eyeicon";
import { MatchError, PasswordWrapper } from "layouts/PublicPage/styles";
import {
  Tooltip,
  Alert,
  Snackbar,
  Box,
  Container,
  Typography,
  Paper,
  Switch,
  Button,
} from "@mui/material";

// Password Form Component
const PasswordForm = ({
  handleSubmit,
  visible,
  setVisible,
  visibleNew,
  setVisibleNew,
  PreviousPassword,
  setPreviousPassword,
  ProposedPassword,
  setProposedPassword,
  ConfirmPassword,
  setConfirmPassword,
  showErrors,
  validatePassword,
  inputRef,
}: // TODO: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
any) => (
  <form onSubmit={handleSubmit}>
    <PasswordWrapper>
      <TextInput
        label="Current Password"
        type={visible ? "text" : "password"}
        placeholder="************"
        value={PreviousPassword}
        onChange={(e) => {
          setPreviousPassword(e.target.value);
        }}
        required
        hasError={showErrors}
        fullWidth
      />
      <PasswordEyeIcon onClick={() => setVisible(!visible)} />
    </PasswordWrapper>
    <Tooltip
      disableFocusListener
      title={
        <>
          <li>Password must contain at least one uppercase</li>
          <li>Password must contain at least one lowercase</li>
          <li>Password must contain at least one numeric digit</li>
          <li>
            Password must contain at least one special character like{" "}
            <code>{"#$%&'(!)*+,-./:;<=>?@[]^_`{|}~"}</code>
          </li>
          <li>Length must be at least 10 characters long</li>
        </>
      }
      placement="right"
      arrow
    >
      <PasswordWrapper>
        <TextInput
          label="New Password"
          type={visibleNew ? "text" : "password"}
          ref={inputRef}
          placeholder="************"
          value={ProposedPassword}
          onChange={(e) => {
            setProposedPassword(e.target.value);
          }}
          hasError={showErrors}
          required
          fullWidth
        />
        <PasswordEyeIcon onClick={() => setVisibleNew(!visibleNew)} />
      </PasswordWrapper>
    </Tooltip>

    {PreviousPassword !== ProposedPassword || PreviousPassword == "" ? null : (
      <MatchError>Old and new password should not be same</MatchError>
    )}
    {validatePassword(ProposedPassword) || ProposedPassword == "" ? (
      ""
    ) : (
      <MatchError>Password Format does not Match</MatchError>
    )}
    <PasswordWrapper>
      <TextInput
        label="Confirm Password"
        type={visibleNew ? "text" : "password"}
        ref={inputRef}
        placeholder="************"
        value={ConfirmPassword}
        onChange={(e) => {
          setConfirmPassword(e.target.value);
        }}
        hasError={showErrors}
        required
        fullWidth
      />
      <PasswordEyeIcon onClick={() => setVisibleNew(!visibleNew)} />
    </PasswordWrapper>
    {ConfirmPassword === ProposedPassword || ConfirmPassword == "" ? null : (
      <MatchError>Confirm password should be as same new password</MatchError>
    )}

    <styles.FormActions>
      <Button
        className="button"
        style={{ minWidth: "200px" }}
        type="submit"
        disabled={
          !PreviousPassword ||
          !ConfirmPassword ||
          !ProposedPassword ||
          !(ConfirmPassword === ProposedPassword || ConfirmPassword == "") ||
          !(PreviousPassword !== ProposedPassword || PreviousPassword == "") ||
          !(validatePassword(ProposedPassword) || ProposedPassword == "")
            ? true
            : false
        }
      >
        Reset Password
      </Button>
    </styles.FormActions>
  </form>
);

export const ChangePassword = () => {
  const navigate = useNavigate();
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [ChangePassword, { data, error }] = useMutation<
    ResetResponse,
    ResetVars
  >(GET_RESET);
  const [showMutationError, setShowMutationError] = useState<boolean>(false);
  const [emailNotifications, setEmailNotifications] = useState<boolean>(true);
  const [originalEmailNotifications, setOriginalEmailNotifications] =
    useState<boolean>(true);
  const [currentUserId, setCurrentUserId] = useState<number | null>(null);
  const [emailPrefLoading, setEmailPrefLoading] = useState(false);

  // Check authentication status and password validity
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const passValid = localStorage.getItem("passValid");
  const isPasswordExpired = passValid === "false";
  const showFullSettings = isLoggedIn && !isPasswordExpired;

  // Query specialists to find current user
  const { data: specialistsData } = useQuery(QUERY_SPECIALISTS);

  // Query to get current email notification preference
  const { data: notificationPrefData, refetch: refetchNotificationPref } =
    useQuery<GetUserNotificationPreferenceResponse>(
      GET_USER_NOTIFICATION_PREFERENCE,
      {
        variables: { userId: currentUserId },
        skip: !currentUserId,
      }
    );

  // Mutation for updating email preferences
  const [updateEmailPreference] = useMutation<
    UpdateEmailNotificationResponse,
    UpdateEmailNotificationVars
  >(UPDATE_EMAIL_NOTIFICATION_PREFERENCE);
  const [visible, setVisible] = useState(false);
  const [visibleNew, setVisibleNew] = useState(false);
  const [showErrors, setShowErrors] = useState<boolean>(false);
  const [PreviousPassword, setPreviousPassword] = useState<string>("");
  const [ProposedPassword, setProposedPassword] = useState<string>("");
  const [ConfirmPassword, setConfirmPassword] = useState<string>("");
  const username = localStorage.getItem("username") || "";

  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const inputRef: any = useRef();

  // Find current user's ID from specialists
  useEffect(() => {
    if (specialistsData?.specialists && username) {
      // Decode base64 username
      let decodedUsername = "";
      try {
        decodedUsername = atob(username);
      } catch (error) {
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line no-console
        console.error("Failed to decode username:", error);
        return;
      }

      const currentSpecialist = specialistsData.specialists.find(
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (specialist: any) => {
          return (
            specialist.email.toLowerCase() === decodedUsername.toLowerCase()
          );
        }
      );

      if (currentSpecialist) {
        setCurrentUserId(currentSpecialist.id);
      }
    }
  }, [specialistsData, username]);

  // Update email notifications state when preference data is loaded
  useEffect(() => {
    if (notificationPrefData?.userNotificationPreference) {
      const enabled =
        notificationPrefData.userNotificationPreference.emailEnabled;
      setEmailNotifications(enabled);
      setOriginalEmailNotifications(enabled);
    }
  }, [notificationPrefData]);

  const validatePassword = (password: string) => {
    const passwordRegex =
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-useless-escape
      /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$).\/;*~":,'(%^&+=!>|<?]).{10,}$/;
    return passwordRegex.test(password);
  };

  useEffect(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleStorageChange = (event: any) => {
      if (event.key === "isLoggedIn" && event.newValue === null) {
        localStorage.clear();
        navigate("/login", { replace: true });
        window.location.reload();
      }
    };

    const username = localStorage.getItem("username");

    if (!username) {
      navigate("/login", { replace: true });
    }

    // Attach the event listener
    window.addEventListener("storage", handleStorageChange);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, [navigate]);

  const handleSubmit = async (e: React.SyntheticEvent) => {
    e.preventDefault();
    setShowErrors(false);
    try {
      if (validatePassword(ProposedPassword)) {
        // Decode base64 username before sending
        let decodedUsername = "";
        try {
          decodedUsername = atob(username);
        } catch (error) {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line no-console
          console.error("Failed to decode username:", error);
          setShowMutationError(true);
          return;
        }

        await ChangePassword({
          variables: {
            username: decodedUsername,
            ProposedPassword: ProposedPassword,
            PreviousPassword: PreviousPassword,
          },
        });
        navigate("/logout");
      } else {
        return new Error(
          "Password must contain atleast one Capital, one Small, one Special Character and length must be minimum 20 characters"
        );
      }
    } catch (error) {
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line no-console
      console.error("Failed to Change Password");
      setShowMutationError(true);
    }
  };

  // Show only password form if user is not fully authenticated or password expired
  if (!showFullSettings) {
    return (
      <PublicPage title={<>Change Password</>}>
        <styles.Container>
          <Box sx={{ mb: 4, textAlign: "center" }}>
            <Typography variant="h5" gutterBottom sx={{ fontWeight: "bold" }}>
              Password Change Required
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Your password has expired. Please change it to continue.
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: 4,
              mb: 3,
              background: "transparent",
              backgroundColor: "none",
              borderRadius: 2,
              border: "1px solid #dddddd",
              maxWidth: "500px",
              mx: "auto",
            }}
          >
            <Typography
              variant="h6"
              component="h4"
              gutterBottom
              sx={{ mb: 3, fontWeight: "bold" }}
            >
              Change Password
            </Typography>

            <PasswordForm
              handleSubmit={handleSubmit}
              visible={visible}
              setVisible={setVisible}
              visibleNew={visibleNew}
              setVisibleNew={setVisibleNew}
              PreviousPassword={PreviousPassword}
              setPreviousPassword={setPreviousPassword}
              ProposedPassword={ProposedPassword}
              setProposedPassword={setProposedPassword}
              ConfirmPassword={ConfirmPassword}
              setConfirmPassword={setConfirmPassword}
              showErrors={showErrors}
              validatePassword={validatePassword}
              inputRef={inputRef}
            />
          </Paper>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={showMutationError}
            onClose={() => setShowMutationError(false)}
          >
            <Alert onClose={() => setShowMutationError(false)} severity="error">
              Failed to change password.
            </Alert>
          </Snackbar>
        </styles.Container>
      </PublicPage>
    );
  }

  // Show full settings page for authenticated users with valid passwords
  return (
    <DefaultAppPage>
      <styles.Container>
        <Container style={{ maxWidth: "700px" }}>
          <Box sx={{ mb: 4 }}>
            <Typography
              variant="h5"
              // component="h2"
              gutterBottom
              sx={{ fontWeight: "bold" }}
            >
              Account Settings
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Manage your account settings and preferences
            </Typography>
          </Box>

          <Paper
            elevation={0}
            sx={{
              p: 4,
              mb: 3,
              background: "transparent",
              backgroundColor: "none",
              borderRadius: 2,
              border: "1px solid #dddddd",
            }}
          >
            <Typography
              variant="h6"
              component="h4"
              gutterBottom
              sx={{ mb: 3, fontWeight: "bold" }}
            >
              Change Password
            </Typography>

            <Box style={{ maxWidth: "700px" }}>
              <PasswordForm
                handleSubmit={handleSubmit}
                visible={visible}
                setVisible={setVisible}
                visibleNew={visibleNew}
                setVisibleNew={setVisibleNew}
                PreviousPassword={PreviousPassword}
                setPreviousPassword={setPreviousPassword}
                ProposedPassword={ProposedPassword}
                setProposedPassword={setProposedPassword}
                ConfirmPassword={ConfirmPassword}
                setConfirmPassword={setConfirmPassword}
                showErrors={showErrors}
                validatePassword={validatePassword}
                inputRef={inputRef}
              />
            </Box>
          </Paper>

          {currentUserId && (
            <Paper
              elevation={0}
              sx={{
                p: 4,
                mb: 3,
                background: "transparent",
                backgroundColor: "none",
                borderRadius: 2,
                border: "1px solid #dddddd",
              }}
            >
              <Typography
                variant="h6"
                component="h2"
                gutterBottom
                sx={{ mb: 3, fontWeight: "bold" }}
              >
                Email Notifications
              </Typography>
              <Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-start",
                    gap: 2,
                  }}
                >
                  <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500 }}>
                      Email Notifications
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      Receive email notifications about patient call events
                      (e.g. when your patients complete calls or miss calls).
                    </Typography>
                  </Box>
                  <Switch
                    checked={emailNotifications}
                    onChange={(e) => {
                      // Just update local state, don't call API
                      setEmailNotifications(e.target.checked);
                    }}
                    disabled={!currentUserId || emailPrefLoading}
                    sx={{
                      "& .MuiSwitch-switchBase.Mui-checked": {
                        color: "#4caf50",
                      },
                      "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                        {
                          backgroundColor: "#4caf50",
                        },
                    }}
                  />
                </Box>
                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Status:{" "}
                    <span
                      style={{
                        color: emailNotifications ? "#4caf50" : "#999",
                        fontWeight: 500,
                      }}
                    >
                      {emailPrefLoading
                        ? "Updating..."
                        : emailNotifications
                        ? "Enabled"
                        : "Disabled"}
                    </span>
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ mt: 4, display: "flex", gap: 2 }}>
                <Button
                  className="button"
                  onClick={async () => {
                    if (currentUserId) {
                      setEmailPrefLoading(true);
                      try {
                        await updateEmailPreference({
                          variables: {
                            userId: currentUserId,
                            input: {
                              emailEnabled: emailNotifications,
                            },
                          },
                        });
                        await refetchNotificationPref();
                        // Update original value after successful save
                        setOriginalEmailNotifications(emailNotifications);
                      } catch (error) {
                        // TODO: Fix this the next time the file is edited.
                        // eslint-disable-next-line no-console
                        console.error("Failed to save preferences:", error);
                        // Revert to original value on error
                        setEmailNotifications(originalEmailNotifications);
                      } finally {
                        setEmailPrefLoading(false);
                      }
                    }
                  }}
                  disabled={
                    !currentUserId ||
                    emailPrefLoading ||
                    emailNotifications === originalEmailNotifications
                  }
                  style={{ minWidth: "200px" }}
                >
                  Save Preferences
                </Button>
              </Box>
            </Paper>
          )}
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={showMutationError}
            onClose={() => setShowMutationError(false)}
          >
            <Alert onClose={() => setShowMutationError(false)} severity="error">
              Failed to change password.
            </Alert>
          </Snackbar>
        </Container>
      </styles.Container>
    </DefaultAppPage>
  );
};
